module.exports = __webpack_public_path__ + "img/28.25a83f36.png";